import { Tag } from 'antd';
import React from 'react';
import styles from "./index.module.css";

// const categoryList=["全部","绘画","其他","刺绣","蜡染","银饰","剪纸",];
const categoryList = [{id:"",label:"全部"},{id:12,label:"绘画"},{id:17,label:"刺绣"},{id:18,label:"蜡染"},{id:19,label:"银饰"},{id:20,label:"剪纸"},{id:16,label:"其他"}];
const Tags = (props) => (
  <div style={{backgroundColor:"#fff",padding:10,display:"flex",marginTop:20}}>
        <div className={styles.proLabel}>作品标签：</div>
		<div>
			{categoryList.map(item=>{
				return(
					<Tag 
						key={item.id} 
						color={props.searchProductCatName===item.id?"#ff8a00":null}
						onClick={() => { props.setSearchProductCatNameFun(item.id);props.setPage(1) }}
						style={{margin:"0 10px 10px 0",cursor:"pointer"}}
					>{item.label}</Tag>
				)
			})}
		</div>
  </div>
);

export default Tags;